import { __assign, __awaiter, __decorate, __generator, __metadata, __param } from "tslib";
import { INetworkRequestService } from '../../../base/request/network-request.interface';
import { getFormDataWithParams } from '../../../base/utils';
import { ADD_TO_MY_FOLDER, FOLDER_LIST, FOLDER_NEW, } from './cgi-path';
import { COMMON_COOKIES_KEYS, getCookieByCommonKey } from '@tencent/ark-utils/lib/cookie';
// 定义权限修改push消息的过滤行为
// 如果本地存在seq记录则忽略消息
export var FILTER_ACTION_IGNORE_IF_LOCAL_EXIST = 1;
var FolderRepository = /** @class */ (function () {
    // networkRequest 注入
    function FolderRepository(networkRequestService) {
        this.networkRequestService = networkRequestService;
    }
    FolderRepository.prototype.folderList = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(FOLDER_LIST, formData)];
            });
        });
    };
    FolderRepository.prototype.newFolder = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(FOLDER_NEW, formData)];
            });
        });
    };
    FolderRepository.prototype.addToMyFolder = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var formData;
            return __generator(this, function (_a) {
                formData = getFormDataWithParams(__assign(__assign({}, params), { xsrf: getCookieByCommonKey(COMMON_COOKIES_KEYS.xsrf) }));
                return [2 /*return*/, this.networkRequestService.instance.post(ADD_TO_MY_FOLDER, formData)];
            });
        });
    };
    FolderRepository = __decorate([
        __param(0, INetworkRequestService),
        __metadata("design:paramtypes", [Object])
    ], FolderRepository);
    return FolderRepository;
}());
export { FolderRepository };
